import { Controller } from "@hotwired/stimulus"
import { Chart, LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip } from "chart.js"

Chart.register(LineController, LineElement, PointElement, LinearScale, CategoryScale, Filler, Tooltip)

export default class extends Controller {
    connect() {
        const labels = JSON.parse(this.element.dataset.chartLabels || "[]")
        const km     = JSON.parse(this.element.dataset.chartKm || "[]")
        const trips  = JSON.parse(this.element.dataset.chartTrips || "[]")

        this.chart = new Chart(this.element.getContext("2d"), {
            type: "line",
            data: {
                labels,
                datasets: [
                    {
                        label: "Kilomètres",
                        data: km,
                        borderColor: getComputedStyle(document.documentElement).getPropertyValue("--ki-primary").trim(),
                        fill: true,
                        backgroundColor: "rgba(68,128,239,.12)",
                        tension: .35,
                        pointRadius: 2
                    },
                    {
                        label: "Trajets",
                        data: trips,
                        borderColor: getComputedStyle(document.documentElement).getPropertyValue("--ki-primary-2").trim(),
                        fill: false,
                        tension: .35,
                        pointRadius: 2
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: { grid: { display:false } },
                    y: { grid: { color: "rgba(255,255,255,.06)" }, ticks: { color: "rgba(255,255,255,.65)" } }
                },
                plugins: {
                    legend: { display:false },
                    tooltip: { mode: "index", intersect: false }
                }
            }
        })
    }

    disconnect() {
        this.chart?.destroy()
    }
}